import Headset from "./SVG/headset.svg?react";

const HeadsetIcon = () => {
  return <Headset />;
};

export default HeadsetIcon;
